import styled from '@emotion/styled'

import {
  AddIcon,
  AlertOutlineIcon,
  AvatarIcon,
  BankAccountIcon,
  BitcoinLightningIcon,
  BlockIcon,
  BulletGenericIcon,
  BusinessIcon,
  CardBasicIcon,
  CheckIcon,
  CommChatIcon,
  CurrencyUsdIcon,
  DateIcon,
  DeliveryIcon,
  DepositIcon,
  DeviceMobileIcon,
  DeviceTapIcon,
  DiscountPercentageIcon,
  DiscountTagIcon,
  DocumentCertificateIcon,
  DocumentCourtOrderIcon,
  DocumentIcon,
  DocumentPaystubIcon,
  DocumentQuillIcon,
  DocumentW2Icon,
  DownloadIcon,
  EditIcon,
  FamilyIcon,
  FavoriteFillIcon,
  FdicIcon,
  GiftcardIcon,
  iconIdMapping,
  IdGovernmentIcon,
  InformationOutlineIcon,
  InternationalIcon,
  InvestingIcon,
  LikeIcon,
  LimitsIcon,
  LocationDuoIcon,
  LocationIcon,
  LockLockedIcon,
  LockUnlockedIcon,
  NoteIcon,
  NumberPadIcon,
  PayLaterIcon,
  RecurringAutomaticIcon,
  RoundUpsIcon,
  SavingsApyIcon,
  SecurityCheckOutlineIcon,
  SensitiveHiddenIcon,
  SensitiveVisibleIcon,
  StickersIcon,
  TaxesIcon,
  TickerUpIcon,
  TimeIcon,
  TimeInfiniteIcon,
  TransferP2PIcon,
  ZeroIcon,
} from '@arcade/web/icons/react'
import { BaseCellProps, SemanticColors } from '@cash-design-system/react'
import { CheckboxCheckedIcon, CheckboxUncheckedIcon, Icon, Logo } from '@cash-design-system/react'
import { ArcadeAvatarFromUiAvatar } from '@cash-web/avatar-from-proto'
import {
  FormBlockerElementSelectableRowElement,
  FormBlockerElementSelectableRowElementIcon,
} from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import logger from '@cash-web/shared/util-logger'

const IconWrapper = styled.span<{ iconColor: SemanticColors }>`
  color: ${({ theme, iconColor }) => theme.arcadeColors.semantic[iconColor]};
`

const getIcon = ({
  icon,
  iconColor,
}: {
  icon?: FormBlockerElementSelectableRowElementIcon
  iconColor: SemanticColors
}) => {
  if (!icon) {
    return
  } else if (icon === FormBlockerElementSelectableRowElementIcon.BANK) {
    return <BankAccountIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.BULLET) {
    return <BulletGenericIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.BUSINESS) {
    return <BusinessIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CALENDAR) {
    return <DateIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CALENDAR_PAY_LATER) {
    return <PayLaterIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CAPITOL) {
    return <TaxesIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CARD) {
    return <CardBasicIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CARD_BALANCE) {
    return <GiftcardIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CASH_APP) {
    return <Logo colorVariant="black" width="1.5rem" />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CHECKMARK) {
    return <CheckIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CLOCK) {
    return <TimeIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.COMM_CHAT) {
    return <CommChatIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CONTACTLESS) {
    return <DeviceTapIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CONTACTS) {
    return <AvatarIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DIRECT_DEPOSIT) {
    return <DepositIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOCUMENT) {
    return <DocumentIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOCUMENTS_CERTIFICATE) {
    return <DocumentCertificateIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOCUMENTS_COURT_ORDER) {
    return <DocumentCourtOrderIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOCUMENTS_FINANCIAL) {
    return <BankAccountIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOCUMENTS_OUTLINE) {
    return <DocumentIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOCUMENTS_PAYSTUB) {
    return <DocumentPaystubIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOCUMENTS_W2) {
    return <DocumentW2Icon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOCUMENTS_WILL) {
    return <DocumentQuillIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.DOLLAR) {
    return <CurrencyUsdIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.EDIT) {
    return <EditIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.ENCIRCLED_PLUS) {
    return <AddIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.EXCLAMATION_MARK) {
    return <AlertOutlineIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.FAMILY) {
    return <FamilyIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.FAVORITES) {
    return <FavoriteFillIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.FDIC_INSURED) {
    return <FdicIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.GIFT_CARD) {
    return <GiftcardIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.GLOBE) {
    return <InternationalIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.GOVERNMENT_IDENTIFIER) {
    return <IdGovernmentIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.HAPPY_FACE) {
    return <StickersIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.HEART) {
    return <LikeIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.INBOX) {
    return <DownloadIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.INFORMATION) {
    return <InformationOutlineIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.INVESTING) {
    return <InvestingIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.KEYPAD) {
    return <NumberPadIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.LIGHTNING) {
    return <BitcoinLightningIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.LOCATION) {
    return <LocationIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.LOCK) {
    return <LockLockedIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.LOCK_UNLOCKED) {
    return <LockUnlockedIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.MOBILE_DEVICE) {
    return <DeviceMobileIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.NEVER_EXPIRES) {
    return <TimeInfiniteIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.NOTE) {
    return <NoteIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.NUMBER_ONE) {
    // TODO: remove this icon usage when we migrate to new icon set for numeral list or keep these custom
    return <Icon name="numeral1" width="1.25rem" height="1.25rem" color={iconColor} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.NUMBER_TWO) {
    return <Icon name="numeral2" width="1.25rem" height="1.25rem" color={iconColor} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.NUMBER_THREE) {
    return <Icon name="numeral3" width="1.25rem" height="1.25rem" color={iconColor} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.PERCENT) {
    return <DiscountPercentageIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.PERSON) {
    return <AvatarIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.PRICE_TAG) {
    return <DiscountTagIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.PRIVACY) {
    return <SensitiveHiddenIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.PROHIBITED) {
    return <BlockIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.RECURRING_DOUBLE_ARROW) {
    return <RecurringAutomaticIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.ROUND_UP) {
    return <RoundUpsIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.SAVINGS_GROWTH) {
    return <SavingsApyIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.SENSITIVE_VISIBLE) {
    return <SensitiveVisibleIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.SHIELD_CHECKMARK) {
    return <SecurityCheckOutlineIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.SPEND_LOCATION) {
    return <LocationDuoIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.TAP_PAYMENT) {
    return <DeviceTapIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.TICKER_UP) {
    return <TickerUpIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.TRUCK) {
    return <DeliveryIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.UNCHECKED_BOX) {
    return <CheckboxUncheckedIcon />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.CHECKED_BOX) {
    return <CheckboxCheckedIcon />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.UP_AND_DOWN_ARROWS) {
    return <TransferP2PIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.UPPER_LIMIT) {
    return <LimitsIcon size={24} />
  } else if (icon === FormBlockerElementSelectableRowElementIcon.ZERO_CROSSED) {
    return <ZeroIcon size={24} />
  } else {
    logger.error(new Error(`SelectableRowElement icon not implemented: ${icon}`))
    return <InformationOutlineIcon size={24} />
  }
}

export const selectableRowElementAsset = ({
  avatar,
  icon,
  localIcon,
  iconColor,
  disabled,
}: {
  avatar?: FormBlockerElementSelectableRowElement['avatar']
  icon?: FormBlockerElementSelectableRowElement['icon']
  localIcon?: FormBlockerElementSelectableRowElement['local_icon']
  iconColor: SemanticColors
  disabled: boolean
}): BaseCellProps['asset'] => {
  if (avatar) {
    return {
      avatar: <ArcadeAvatarFromUiAvatar uiAvatar={avatar} disabled={disabled} size="small" />,
    }
  }

  if (localIcon) {
    const icon = localIcon.arcade_id ? iconIdMapping[localIcon.arcade_id] : undefined
    if (!icon) {
      // If this error is logged either:
      //   - add entry to iconIdMapping for missing arcadeIconId
      //   - or if the icon id is wrong have the responsible server team change the value
      logger.error(new Error(`No mapping found for the arcade icon id of ${localIcon.arcade_id}`))
    } else {
      return { Icon: icon?.Icon }
    }
  }

  if (icon) {
    return { avatar: <IconWrapper iconColor={iconColor}>{getIcon({ icon, iconColor })}</IconWrapper> }
  }

  return undefined
}
